module.exports = "<h2>Error</h2>\r\n\r\n<h3>Description</h3>\r\n<div>{{vm.reason.description}}</div>\r\n\r\n<h3>Message</h3>\r\n<div>{{vm.reason.message}}</div>\r\n\r\n<h3>Number</h3>\r\n<div>{{vm.reason.number}}</div>\r\n\r\n<h3>Status</h3>\r\n<div>{{vm.reason.status}}</div>\r\n\r\n<h3>Status text</h3>\r\n<div>{{vm.reason.statusText}}</div>\r\n\r\n<h3>Url</h3>\r\n<div>{{vm.reason.url}}</div>\r\n\r\nLong reason:\r\n<div>{{vm.reason}}</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/core/errorpage.html
// module id = 1335
// module chunks = 1